import heliosLogoLight from '../assets/common/HCAI Light.png';
import heliosLogoDark from '../assets/common/HCAI Dark.png';
import { useTheme } from "../contexts/ThemeContext";
import LoginButton from '../components/auth/LoginButton';

import { useAuth0 } from "../components/auth/DevAuth0Provider";
import { useAuthUser } from "../contexts/AuthUserContext";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";


import { Icon } from "@iconify/react";

function LoginPage() {
  const { isAuthenticated, isLoading, error, clearAuthState } = useAuth0();
  const user = useAuthUser();
  const navigate = useNavigate();
  const { theme } = useTheme();

  const logo = theme === 'dark' ? heliosLogoDark : heliosLogoLight;

  // Animation states
  const [animationStates, setAnimationStates] = useState({
    logo: false,
    header: false,
    container: false
  });

  // Trigger staggered animations on component mount
  useEffect(() => {
    const timeouts = [];

    // Stagger the animations with delays
    timeouts.push(setTimeout(() => {
      setAnimationStates(prev => ({ ...prev, logo: true }));
    }, 200));

    timeouts.push(setTimeout(() => {
      setAnimationStates(prev => ({ ...prev, header: true }));
    }, 400));

    timeouts.push(setTimeout(() => {
      setAnimationStates(prev => ({ ...prev, container: true }));
    }, 600));

    // Cleanup timeouts on unmount
    return () => {
      timeouts.forEach(timeout => clearTimeout(timeout));
    };
  }, []);

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // Navigate to /app and let RoleBasedRedirect handle the proper destination
      // This ensures default page preferences are respected
      navigate("/app");
    }
  }, [isAuthenticated, isLoading, navigate]);

  return (
    <div className="login-page">

      <img
        src={logo}
        className={`app-logo transition-all duration-1000 ease-out-in ${
          animationStates.logo
            ? 'opacity-100'
            : 'opacity-0'
        }`}
        alt="Helios Core AI Logo"
      />

      <div className={`login-header transition-all duration-1000 ease-out-in ${
        animationStates.header
          ? 'opacity-100'
          : 'opacity-0'
      }`}>
        <div className='login-title flex flex-row items-center gap-2 justify-center'>
          <Icon icon="mdi:administrator-outline" className='text-3xl text-primary'></Icon>
          <h4 className='text-2xl font-medium'>Administrator Login</h4>
        </div>
        <p className='text-lg text-font-secondary'>Secure access for Helios administrators</p>
      </div>

      <div className={`login-container card-container transition-all duration-1000 ease-out-in ${
        animationStates.container
          ? 'opacity-100'
          : 'opacity-0'
      }`}>
        {error?.message && (
          <div
            role="alert"
            className="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-left text-sm text-red-900 dark:border-red-900/50 dark:bg-red-950/40 dark:text-red-100"
          >
            <div className="flex items-start justify-between gap-3">
              <p className="flex-1 leading-relaxed">{error.message}</p>
              <button
                type="button"
                onClick={() => clearAuthState()}
                className="shrink-0 rounded px-2 py-1 text-xs font-medium text-red-800 underline-offset-2 hover:underline dark:text-red-200"
              >
                Dismiss
              </button>
            </div>
          </div>
        )}
        <LoginButton />
        <div className='flex flex-col gap-2'>
          <p className='text-lg'>1. Enter your Organization's <span className='text-primary'>First word in Lowercase</span>. <br /> <span className='text-sm text-font-secondary'>(Example: "helios" for Helios Core)</span></p>
          <p className='text-lg'>2. Input your Login Credentials.</p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;